<template>
  <div class="d-flex pagetipspintsale">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="py-3">
        <!-- <div class="content-loader" v-if="loading">
          <div id="loader2"></div>
          <div class="cssload-dots">
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
          </div>
        </div> -->
        <!--div class="container"-->
        <div class="row mb-4">
          <div class="col-12 m-0 pl-4">
            <div class="title-view ml-4">Ajuste de Puntos de Ventas</div>
          </div>
        </div>
        <div class="row ">
          <div class="col-12 m-0 pl-4 ">
            <filter-content @limpiar="limpiar" @historial="ver_historial" :loading="loadingIndex" :showHistorial="false"
              imgClass="col-md-4" :disabledBtnLimpiar="disabledBtnLimpiar">
              <div class="col-md-6 mt-4">
                <span class="cta" style="color: #5d5fef">Escenario</span>
                <div class="border-top pt-4">
                   <b-form-checkbox-group size="lg">
                  <b-form-checkbox
                    v-for="scenario in pointSaleIndex.scenarios"
                    v-model="escenario"
                    :key="scenario.id"
                    :value="scenario.id"
                  >
                    {{ scenario.name }}
                  </b-form-checkbox>
                </b-form-checkbox-group>  

                  <!--select @change="cambioelselect($event)" v-model="escenario"
                    class="buscar-empleado redondo-8 w-100 mt-4 mb-2">
                    <option v-for="scenario in pointSaleIndex.scenarios" :key="scenario.id" :value="scenario.id">
                      {{ scenario.name }}
                    </option>
                  </select-->

                </div>
              </div>
              <div class="col-md-6 mt-4 pb-4">
                <span class="cta" style="color: #5d5fef">Punto de venta</span>
                <div class="border-top pt-4">

                  <div class="buscar-empleado mt-4 mb-4">
                    <div class="input-group-prepend">
                      <span class="icon">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M8.1665 0.666656C12.3065 0.666656 15.6665 4.02666 15.6665 8.16666C15.6665 12.3067 12.3065 15.6667 8.1665 15.6667C4.0265 15.6667 0.666504 12.3067 0.666504 8.16666C0.666504 4.02666 4.0265 0.666656 8.1665 0.666656ZM8.1665 14C11.389 14 13.9998 11.3892 13.9998 8.16666C13.9998 4.94332 11.389 2.33332 8.1665 2.33332C4.94317 2.33332 2.33317 4.94332 2.33317 8.16666C2.33317 11.3892 4.94317 14 8.1665 14ZM15.2373 14.0592L17.0051 15.8263C17.3308 16.1519 17.3309 16.6798 17.0053 17.0054C16.6797 17.331 16.1517 17.331 15.8262 17.0053L14.059 15.2375L15.2373 14.0592Z"
                            fill="#546E7A" />
                        </svg>
                      </span>
                    </div>
                    <b-overlay :show="loadingPdvs" class="w-100">
                      <vue-bootstrap-typeahead ref="vueBootstrapTypeaheadPDV"
                        inputClass="redondo-8 form-control form-control-lg  w-100" v-model="bodegaSelectedName"
                        :data="pdvs" :serializer="(item) => item.name" @hit="pdvSeleccionado = $event"
                        placeholder="Buscar ...">
                      </vue-bootstrap-typeahead>
                      <template #overlay>
                        <overlay-button class="float-none"></overlay-button>
                      </template>
                    </b-overlay>

                   
                  </div>


                </div>
              </div>
            </filter-content>
          </div>
        </div>

        <div class="row">



          <div class="col-md-8 col-sm-12">
            <div class="buscar-empleado mt-4 mb-4">
              <div class="input-group-prepend">
                <span class="icon icon-search1"></span>
              </div>
              <input type="search" placeholder="Buscar Punto de Venta" aria-label="Buscar Punto de Venta"
                autocomplete="off" class="form-control body_regular" v-model="filter" style="border: 0px"
                @keydown="startTipyng()" @keyup="finishTipyng()" />
            </div>
          </div>
      
          <div class="mt-5" v-if="loading" id="loader"></div>
          <div v-else class="col-12 ml-1 mt-2 mb-1 mr-2">
            <datatable :columns="datatable.columns" :data="datatable.rows" :filter="datatable.filter"
              :per-page="datatable.perPage" :page="datatable.page"
              class="col-12 mt-5 table table-hover table-borderless">
              <template slot-scope="{ row, columns }">
                <tr @click="editPointsSales(row)">
                  <template>
                    <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row">
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
              <Pagination :data="pointsSales.data" :limit="10" @pagination-change-page="getFilterDp">
                <template #prev-nav>
                  <span>&lt;</span>
                </template>
                <template #next-nav>
                  <span>&gt;</span>
                </template>
              </Pagination>
            </div>
          </div>













          <div class="col-md-12">
            <div class="ml-4 mt-2 mb-1 mr-0">
              <Tipspointsaletable @ver="verRegistro" @paginar="obtenerDatatableFilter" :registros="pointSales"
                :loading="loading"></Tipspointsaletable>
            </div>
            <div class="ml-4 mt-2 mb-1 mr-0">
              <Tipspointsaletable @ver="verRegistro" @paginar="getFilterDp" :registros="pointsSales.data"
                :loading="loading"></Tipspointsaletable>
            </div>
          </div>
        </div>
        <!-- .row -->
        <!--/div-->
        <!-- .layout-content -->
      </div>

      <!-- Modal editar -->
      <FormModal :id="idFormModal" :title="pointsale.name">
        <TipspointsaleForm @confirmar="abriModalConfirmar" :list="pointSaleIndex" :pointsale="pointsale" />
      </FormModal>
      <!-- Modal Confirmar -->
      <confirm-modal :id="idConfirModal" title="" size="md" variantAlert="warning" textAlert="textAlertModal"
        :iconAlert="true" :eliminarRegistro="eliminarRegistro">
        <TipspointsaleShow :pointsale="pointsale" :scenario="scenarioSeleccionado" :loadingPrevius="loadingSave"
          :loadingSave="loadingSave" @editar="editar" @cancelar="cancelar" />
      </confirm-modal>

      <!-- Modal OK -->
      <InfoModal :id="idInfoModal" :title="titleInfo" :content="
        this.error
          ? typeof this.error === 'object'
            ? 'Error consultando los datos'
            : this.error
          : this.message
      " :status="
  this.error
    ? typeof this.error === 'object'
      ? 'danger'
      : 'danger'
    : 'success'
" @entendido="$bvModal.hide(idInfoModal)" />

      <!-- Historial -->
      <HistoryModal :id="idHistoryModal" size="lg" title="Historial de modificaciones realizadas">
        <TipspointsaleTableHistory :loading="loadingHistorial" :registros="historial" @paginar="paginarHistory" />
      </HistoryModal>
    </div>
  </div>

  <!-- #page-tips-pint-sale -->
</template>
<script>
import HeadingUser from "@/components/user/HeadingUser.vue";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import FilterContent from "@/components/core/filters/filter-content.vue";
import { mapActions, mapState } from "vuex";
import Tipspointsaletable from "./components/tips-point-sale-table.vue";
import TipspointsaleForm from "./components/tipspointsale-form.vue";
import TipspointsaleShow from "./components/tipspointsale-show.vue";
import TipspointsaleTableHistory from "./components/tipspointsale-table-history.vue";
import FormModal from "@/components/core/modal/form-modal.vue";
import ConfirmModal from "@/components/core/modal/confirm-modal.vue";
import InfoModal from "@/components/core/modal/info-modal.vue";
import HistoryModal from "@/components/core/modal/history-modal.vue";
import overlayButton from "@/components/core/overlay/overlay-button.vue";

export default {
  name: "tipspointsale",
  components: {
    MainBarMenuV2,
    HeadingUser,
    FilterContent,
    Tipspointsaletable,
    TipspointsaleTableHistory,
    FormModal,
    TipspointsaleForm,
    ConfirmModal,
    TipspointsaleShow,
    InfoModal,
    HistoryModal,
    overlayButton,
  },
  data() {
    return {
      id: [],
      idFormModal: "modal-scoped",
      idConfirModal: "modal-confir",
      idInfoModal: "modal-ok",
      idHistoryModal: "modal-history",
      eliminarRegistro: true,
      escenario: [],
      pagina: 1,
      bodegaSelected: null,
      bodegaSelectedName: null,
      pdvSeleccionado: null,

filter:"",//agregado para prueba
datatable: {
        total: 18,
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      },




      paramHistory: {
        modification_type: 2,
        origin: [1],
        page: 1,
      },
      delay: 1500,
    };
  },

  watch: {
    escenario: function () {
      this.obtenerDatatable();
    },
    bodegaSelected: function () {
      this.obtenerDatatable();
    },
    pdvSeleccionado: function (event) {
      this.bodegaSelected = event.id;
      this.pdvSeleccionado = event;
      console.log("bo",this.bodegaSelected );
    },
  },
  mounted() {
    if (localStorage.user) {
      this.id = this.user.core_role_id;
    } else alert();
  },
  beforeMount() {
    this.getPdv();
  },
  computed: {
    ...mapState("modCore", ["user", "userData"]),
    ...mapState("modTipshiftPointSale", [
      "pointSaleIndex",
      "loadingSave",
      "historial",
      "loading",
      "pointSales",
      "pointsale",
      "loadingIndex",
      "error",
      "message",
      "loadingHistorial",
      "pdvs",
      "loadingPdvs",
    ]),


    ...mapState("modPlatformSettings", [
      "pointsSales",
      "pointsSale",
      "loading",
      "error",
      "message",
    ]),//Agregado para Prueba



    titleInfo() {
      console.log("E-",this.error);
      return this.error ? "¡Error!" : "¡Proceso exitoso!";
    },

    disabledBtnLimpiar() {
      return this.escenario.length > 0 || this.bodegaSelected != null
        ? false
        : true;
    },

    scenarioSeleccionado() {
      return this.pointSaleIndex.scenarios
        ? this.pointSaleIndex.scenarios.find(
          (scenario) => scenario.id == this.pointsale.pro_scene_id
        )
        : null;
    },
  },

  methods: {
    ...mapActions("modTipshiftPointSale", [
      "actGetDatatable",
      "actSavePdvEscenarios",
      "actGetIndex",
      "actSetPointSale",
      "actGetHistorialTables",
      "actGetPdvs",
    ]),

//Agregado para prueba

...mapActions("modPlatformSettings", [
      "actLineDeals",
      "actGetZonesByLB",
      "actPointsSales",
      "actPointSales",
      "actSavePointSale",
      "actUpdatePointSale",
      "actDeletePointSale",
    ]),
    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        this.getFilterDp();
      }, 1500);
    },
    getPointsSales() {
      let page = [];
      page = {
        page: this.datatable.page,
      };

      this.actPointsSales(page).then(() => {
        if (this.lineDeals.data) {
          this.pointsSales.data.data.forEach((x) => {
            this.datatable.rows.push({
              id: x.id,
              code: x.code,
              name: x.name,
              line_deal_name: x.line_deal_name,
            });
          });
        }
      });
         },
    
         getFilterDp(page = 1) {
      let data2 = [];
      data2 = {
        page: page,
        filter: this.filter,
      };
      this.actPointsSales(data2).then(() => {
        this.datatable.rows = [];
        if (this.lineDeals.data) {
          this.pointsSales.data.data.forEach((x) => {
            this.datatable.rows.push({
              id: x.id,
              code: x.code,
              name: x.name,
              line_deal_name: x.line_deal_name,
            });
          });
        }
      });
     // this.loadRows();
    },






    cambioelselect(event) {
      this.escenario = event.target.value;

    },
    obtenerDatatableFilter(pagina) {
      this.pagina = pagina;
      this.obtenerDatatable();
    },

    obtenerDatatable() {
      let data = [];
      data = {
        page: this.pagina,
        pro_scene_id: this.escenario,
        point_sale_id: this.bodegaSelected,
      };
      console.log("datatable",data);
      console.log("datatable2",this.actGetDatatable(data));
    },

    limpiar() {
      this.bodegaSelected = null;
      this.escenario = [];
      this.$refs.vueBootstrapTypeaheadPDV.inputValue = "";
    },

    getPdv() {
      // Obtener la cargar de la página
      this.actGetIndex();
      // Obtener el listado de turnos
      this.obtenerDatatable();
      // Obtener el listado de autocomplete
      this.getFilterDp();
     // this.actGetPdvs();
    },

    verRegistro(row) {
      // ABRIR MODAL
      this.actSetPointSale(row);
      this.$bvModal.show(this.idFormModal);
    },

    abriModalConfirmar() {
      this.$root.$emit("bv::hide::modal", this.idFormModal);
      this.$root.$emit("bv::show::modal", this.idConfirModal);
    },

    editar() {
      // Guardar escenario
      let data = {
        pro_scene_id: this.pointsale.pro_scene_id,
        id: this.pointsale.id,
      };
      //this.bodegaSelected =  this.pointsale.pro_scene_id;
      //this.pdvSeleccionado = this.pointsale.id;
      console.log("editar",data);
      this.actSavePdvEscenarios(data).then(() => {
        this.$bvModal.hide(this.idConfirModal);
        console.log("desp_editar",data);
        console.log("hay error",this.error,this.message);

        this.$bvModal.show(this.idInfoModal);
        this.obtenerDatatable();
      });
    },

    cancelar() {
      this.$bvModal.hide(this.idConfirModal);
      this.$bvModal.show(this.idFormModal);
    },

    actualizarTabla(response) {
      this.datatable.rows = response.data.data;
      this.datatable.last_page = response.data.last_page;
      this.datatable.per_page = response.data.per_page;
      this.datatable.total = response.data.total;
    },
    ver_historial() {
      this.$bvModal.show(this.idHistoryModal);
      this.actGetHistorialTables(this.paramHistory);
    },

    paginarHistory(page) {
      this.paramHistory.page = page;
      this.actGetHistorialTables(this.paramHistory);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagetipspintsale {

  .collapsed>.when-opened,
  :not(.collapsed)>.when-closed {
    display: none;
  }

  input[type="checkbox"] {
    display: none;


  }

  input[type="checkbox"]+label {

    margin-left: 25px;

  }

  input[ type=checkbox]+label:before {
    content: "";
    display: inline-block;


    width: 20px;
    height: 20px;


    border: 1px solid #7A7CFF;
    box-sizing: border-box;
    border-radius: 2px;
    text-align: center;
    vertical-align: text-top;
    line-height: 15px;
    margin: 3px 12px -3px 1px;
    padding: 0px;
    position: realtive;
    left: 28px;

  }

  input[ type=checkbox]:checked+label:before {
    content: "\02713";
    //font-size:10px;
    background: #5D5FEF;
    border-radius: 2px;
    color: #fff;

  }

  input[ type=checkbox]:focus+label:before {
    box-shadow: 0px 0px 3px 1px #ccc;
  }

  input[ type=checkbox]:hover+label:before {
    box-shadow: 0px 0px 4px #5D5FEF;
  }

}

.filtros-open {
  width: 1002px;
}


.filtros {

  display: flex;
  width: 100%;
  height: 216px;

  margin-bottom: 24px;

  flex-direction: column;

  /* content/00 */

  background: #FFFFFF;
  /* Bottom */
  //background-image: url("../../assets/images/icons/vector-seacrh-filter.svg");
  background-image: url("../../assets/images/onboarding/add_information.svg");
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: 20%;

  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14);
  border-radius: 12px;
}
</style>